import React, { FC, ReactElement } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';

import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import IdeaUpdateAttachment from '@buyside/components/presentation/IdeaShowPage/AuthorActions/IdeaUpdateSections/ideaUpdateAttachment';
import { IdeaUpdateFormValues } from '@buyside/components/presentation/IdeaShowPage/AuthorActions/ideaUpdateForm';

import styles from '@buyside/components/presentation/IdeaShowPage/AuthorActions/authorActionsStyles.scss';

const IdeaUpdateAttachments: FC = (): ReactElement => {
  const {
    control,
    watch,
    formState: { isSubmitting }
  } = useFormContext<IdeaUpdateFormValues>();

  const { remove, append } = useFieldArray({ control, name: 'attachments' });

  const attachments = watch('attachments');

  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionHeader}>
        <strong>Add attachments to your update</strong>
        <span> (Optional)</span>
      </div>
      {attachments.map((attachment, idx) => (
        <IdeaUpdateAttachment
          attachment={attachment}
          idx={idx}
          key={`${attachment?.id}-${idx}}`}
          remove={remove}
        />
      ))}
      <Button
        buttonType={BUTTON_TYPES.BUTTON}
        disabled={isSubmitting}
        faIcon={faPlus}
        text="Add Attachment"
        onClick={(): void => {
          append({
            attachmentType: '',
            file: null,
            filename: '',
            researchType: ''
          });
        }}
        type={BUTTON_TYPES.LINK}
      />
    </div>
  );
};

export default IdeaUpdateAttachments;
